import { render, staticRenderFns } from "./mainThree.vue?vue&type=template&id=a0f4b684&scoped=true&"
import script from "./mainThree.vue?vue&type=script&lang=js&"
export * from "./mainThree.vue?vue&type=script&lang=js&"
import style0 from "./mainThree.vue?vue&type=style&index=0&id=a0f4b684&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4b684",
  null
  
)

export default component.exports